import styled from 'styled-components';

export const CardWrap = styled.ul`
  display: flex;
  flex-flow: row wrap;
  margin-top: 20px;

  @media (max-width: 480px) {
    margin-top: 0;
  }

  a {
    display: block;
    color: #fff;
    position: relative;
  }

  a {
    display:flex;

  }
  li {
    flex-basis: calc(100%/3 - 30px);
    background-color: #554f4d;
    border-radius: 15px;
    margin: 15px;
    height: 250px;
    transition: all .3s linear;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    @media (max-width: 1000px){
      flex-basis: calc(100%/2 - 30px);
    }

    @media (max-width: 500px){
      margin: 20px auto;
      flex-basis: calc(100% - 100px);
    }

    &:hover {
      background-color: #79706d;
    }
  }

  h3 {
    margin-top: 10px;
    font-size: 20px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 4.3em;
    line-height: 1em;
    @media (max-width: 480px){
      font-size: 16px;
    }
  }

  img {
    width: 80px;
    display: block;
    margin: 0 auto;
    height:auto
  }

  div{
    display: flex;
    flex-direction: column;
  }

  div {
    box-sizing: border-box;
    width: 100%;
    height: 150px;
    // opacity: 0.5;
    padding: 0 20px;
    background-color: rgba(85, 79, 77, 0.5) ;
    border-radius: 0 0 15px 15px;
  }

  p {
    margin-top: 10px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 3.6em;
    line-height: 1.2em;
  }

  span {
    font-weight: 700;
  }
`;





// WEBPACK FOOTER //
// ./src/system/cards-institutions/components.js